import { Inject } from '@odinjs/odin';

import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import { DeckAPI, FetchAPI, PanelAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnCancel, OnClick, OnClose, OnMount, OnSelectItem, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SelectItemEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import { IndicatorHistoriesAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface IndicatorHistory {
  dsHistory: string,
  nrSeqIndicatorHistory: number,
}

@Controller({ fragment: FragmentNames.INDICATOR_HISTORIES })
class IndicatorHistoriesController extends BaseController {

  @Inject(Aliases.PANEL_HISTORY)
  private panelHistory: PanelAPI;
  @Inject(Aliases.PANEL_ADD_HISTORY)
  private panelAddHistory: PanelAPI;
  @Inject(Aliases.FETCH_HISTORIES)
  private fetchHistories: FetchAPI;

  @OnMount(Aliases.FETCH_HISTORIES)
  onMountFechAliases(event: MountEvent): void {
    const { nrSeqProviderIndicator } = this.historyService.getCurrentRouteParams();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqProviderIndicator });
    api.forceFetch();
  }

  @OnSelectItem(Aliases.DECK_HISTORIES)
  onSelectHistory(event: SelectItemEvent<IndicatorHistory>): void {
    const api = event.target as unknown as DeckAPI;
    const nrSeqIndicatorHistory = event.item.nrSeqIndicatorHistory;
    this.context.set({ nrSeqIndicatorHistory });
    api.unselectAll();
    this.panelHistory.setVisible(true);
  }

  @OnMount(Aliases.FETCH_HISTORY)
  onMountFetchHistory(event: MountEvent): void {
    const { nrSeqProviderIndicator } = this.historyService.getCurrentRouteParams();
    const { nrSeqIndicatorHistory } = this.context.getBulkData();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqProviderIndicator, nrSeqIndicatorHistory });
  }

  @OnClose(Aliases.MODAL_HISTORY)
  onCloseModalHistory(): void {
    this.panelHistory.setVisible(false);
  }

  @OnClick(Aliases.ACTION_ADD_HISTORY)
  onClickAddHistory(): void {
    this.panelAddHistory.setVisible(true);
  }

  @OnClose(Aliases.MODAL_ADD_HISTORY)
  onCloseModalAddHistory(): void {
    this.panelAddHistory.setVisible(false);
  }

  @OnSubmit(Aliases.FORM_ADD_HISTORY)
  onSubmitFormAttachment(event: SubmitEvent): void {
    const { record } = event;
    const { nrSeqProviderIndicator } = this.historyService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.ADD_INDICATOR_HISTORY, { nrSeqProviderIndicator }, { body: record }).then(() => {
      this.panelAddHistory.setVisible(false);
      this.fetchHistories.setParameters({ nrSeqProviderIndicator });
      this.fetchHistories.forceFetch();
      ToastService.open({ level: ToastLevel.SUCCESS, message: MessageService.translate('provider.request-sucessfull') });
    }).catch((error) => {
      ToastService.open(error);
    });
  }

  @OnCancel(Aliases.FORM_ADD_HISTORY)
  onCancelForm(): void {
    this.panelAddHistory.setVisible(false);
  }

}

export { IndicatorHistoriesController };
